module.exports = __webpack_public_path__ + "static/media/india-emblem.ee186546.png";